import { createSignal } from 'solid-js';

export const formatLabel = (label: string, isRequired: boolean): string =>
    isRequired ? `${label} *` : label;

export const createFocusState = () => {
    const [isFocused, setIsFocused] = createSignal(false);

    const onFocus = () => setIsFocused(true);

    const onBlur = (hasValue: boolean) => {
        if (!hasValue) setIsFocused(false);
    };

    return { isFocused, onFocus, onBlur };
};